/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OpcuaConfigUpdate } from '../../models/opcua-config-update';

export interface UpdateOpcuaConfiguration$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected opcua configuration
 */
  opcuaUid: string;
  
    /**
     * The OPCUA update object
     */
    body: OpcuaConfigUpdate
}

export function updateOpcuaConfiguration(http: HttpClient, rootUrl: string, params: UpdateOpcuaConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateOpcuaConfiguration.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('opcuaUid', params.opcuaUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateOpcuaConfiguration.PATH = '/stations/{uid}/opcua/{opcuaUid}';
